const API = process.env.REACT_APP_BACKEND_URL;
const SERVER_EVENTS = new Set(["Lead", "Contact", "CompleteRegistration", "SubmitApplication", "Schedule", "InitiateCheckout"]);

const canTrack = () => typeof window !== "undefined" && typeof window.fbq === "function";

export const newEventId = (prefix = "ev") => `${prefix}_${typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)}`;

const cookie = (name) => document.cookie.split("; ").find((x) => x.startsWith(name + "="))?.split("=")[1];
export const metaCookies = () => ({ fbp: cookie("_fbp") || null, fbc: cookie("_fbc") || null, page_url: window.location.href });

const post = (path, body) => fetch(`${API}/api/meta/${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});

export const pixel = (event, params, opts = {}) => {
  const eventId = opts.eventId || newEventId(event.toLowerCase());
  if (canTrack()) {
    try { window.fbq("track", event, params || {}, { eventID: eventId }); } catch (e) { /* noop */ }
    if (event !== "PageView") post("browser", { event_name: event, event_id: eventId, custom_data: params || {} });
  }
  if (opts.server && SERVER_EVENTS.has(event)) post("events", { event_name: event, event_id: eventId, ...metaCookies(), custom_data: params || {} });
  return eventId;
};

export const pixelCustom = (event, params) => {
  if (!canTrack()) return;
  try { window.fbq("trackCustom", event, params || {}); } catch (e) { /* noop */ }
};

const ONCE_KEY = "affinity.px.once";
export const pixelOnce = (key, event, params, opts) => {
  let seen = {};
  try { seen = JSON.parse(sessionStorage.getItem(ONCE_KEY) || "{}"); } catch (e) { seen = {}; }
  if (seen[key]) return null;
  seen[key] = 1;
  try { sessionStorage.setItem(ONCE_KEY, JSON.stringify(seen)); } catch (e) { /* noop */ }
  return pixel(event, params, opts);
};
